import type { UseQueryOptions } from '@tanstack/react-query';
import { type PublicGivingContentObject, createPublicGivingContentObject } from 'models';
import { useQuery } from 'query';
import type { ApiClientResponseError, ResponseErrorDataObject } from 'common/services';
import { getPublicGivingDetail } from '../services';
import { getGivingDetailQueryKey } from './keys';

type P = {
  id: string;
  options?: Partial<UseQueryOptions<PublicGivingContentObject, ApiClientResponseError<ResponseErrorDataObject>>>;
};

export const usePublicGivingQuery = ({ id, options }: P) =>
  useQuery<PublicGivingContentObject>({
    async queryFn() {
      const { data } = await getPublicGivingDetail({ routeParams: { id } });

      return createPublicGivingContentObject(data);
    },
    queryKey: getGivingDetailQueryKey({ givingId: id, view: 'public' }),
    ...options,
  });
